<template>
        <div class="text-center">
            <v-dialog
    v-model="localDialog"
    max-width="1135px"
    max-height="575px"
    scrollable
    class="mx-auto"
  >
    <v-card max-width="1135px" max-height="575px">
      <v-card-title style="font-size: 28px; font-weight: 500">
        {{$t("table.reportrooms") }}
        <v-spacer></v-spacer>
        <v-btn class="float-right" icon @click="localDialog = false">
          <v-icon style="font-size: 22px"> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="pt-0 mt-2"></v-divider>
      <v-card-text>
        <div id="testHtml" ref="testHtml">
          <v-row no-gutters>
            <v-col cols="12" md="12" sm="12" xs="12">
              <div class="hidden" v-show="!$vuetify.breakpoint.mobile || !$vuetify.breakpoint.xs"></div>
              <v-row no-gutters class="ml-1 mt-4">
                <v-col cols="12" md="2" xs="12" sm="12">
                  <span style="color: #000000; font-size: 20px">{{$t("roomsetting.roomname") }} : </span>
                </v-col>
                <v-col cols="12" md="10" xs="12" sm="12">
                  <span style="font-size: 18px">{{dataparticipants.room_name}}</span>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-1 mt-4">
                <v-col cols="12" md="2" xs="12" sm="12">
                  <span style="color: #000000; font-size: 20px">{{$t("message.day") }}/{{$t("message.time") }} : </span>
                </v-col>
                <v-col cols="12" md="10" xs="12" sm="12" >
                  <!-- <span style="font-size: 18px">
                    เริ่ม : {{ setdatestartend(dataparticipants.start_time)}} , เวลา : {{settimestartend(dataparticipants.start_time)}}
                  </span> -->
                  <span style="font-size: 18px">
                    {{$t("message.start") }} : {{ dataparticipantsend.s_date }} , {{$t("message.time") }} : {{ (dataparticipantsend.s_time) }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-1">
              </v-row>
              <v-row no-gutters class="ml-1 mt-4">
                <v-col cols="12" md="2" xs="12" sm="12">
                  <span style="color: #000000; font-size: 20px"> </span>
                </v-col>
                <v-col cols="12" md="10" xs="12" sm="12">
                  <span style="font-size: 18px">
                    <!-- สิ้นสุด : {{ setdatestartend(dataparticipants.end_time)}} , เวลา : {{settimestartend(dataparticipants.end_time)}} -->
                    {{$t("message.end") }} : {{  (dataparticipantsend.e_date) }} , {{$t("message.time") }} :  {{ (dataparticipantsend.e_time) }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-1 mt-4">
              </v-row>
              <!-- <v-row no-gutters class="ml-1">
                <v-col cols="8" md="3" xs="8" sm="8" class="mt-4">
                  <span style="color: #000000; font-size: 20px"
                    >จำนวนผู้เข้าร่วม :
                  </span>
                </v-col>
                <v-col cols="4" md="9" xs="4" sm="4" class="mt-4">
                  <span style="font-size: 20px" class="ml-2"> {{ datareporthistory.length }} ท่าน</span>
                </v-col>
              </v-row> -->
              <v-row no-gutters class="ml-1">
                <v-col
                  cols="12"
                  md="12"
                  xs="12"
                  sm="12"
                  class="mt-10"
                  align-self="center"
                >
                  <span style="color: #04449f; font-size: 22px"
                    >{{$t("table.tablereport") }}
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters class="text-center mt-3 ml-n2">
                <v-col class="mb-6">
                  <div>
                    <v-container>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #04449f" class="text-center">
                              <th
                                style="color: white; font-size: 16px"
                                class="text-center pt-3 pb-3"
                                width="10%"
                              >
                              {{$t("table.No") }}
                              </th>
                              <th
                                style="color: white; font-size: 16px"
                                class="text-center pt-3 pb-3"
                                width="35%"
                              >
                              {{$t("table.Namemeet") }}
                              </th>
                              <th
                                style="color: white; font-size: 16px"
                                class="text-center pt-3 pb-3"
                                width="35%"
                              >
                              {{$t("table.timeinout") }}
                              </th>
                              <th
                                style="color: white; font-size: 16px"
                                class="text-center pt-3 pb-3"
                                width="15%"
                              >
                              {{$t("table.period") }}
                              </th>
                              <!-- <th
                                style="color: white; font-size: 16px"
                                class="text-center pt-3 pb-3"
                                width="25%"
                              >
                              {{$t("table.annotation") }}
                              </th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, no) in datareporthistory" :key="no">
                              <td class="text-center">{{ no+1 }}</td>
                              <td class="text-center" >
                                <v-icon color="#808000" class="pr-2" v-if="item.role == 'chair'">mdi-crown-circle</v-icon>
                                {{ item.name }}
                              </td>
                              <td class="text-center">
                                <!-- {{settimeuser(item)}} -->
                                {{ item.join_date }} {{item.join_time }} - {{item.out_date }} {{item.out_time }}
                                <!-- {{settimestartend(item.start_time)}} -->
                                <!-- {{item.start_time.substring(11)}} - {{item.end_time.substring(11)}} -->
                                <!-- {{settimestartend(item.start_time)}} - {{settimestartend(item.start_time)}} -->
                              </td>
                               <td class="text-center" v-if="item.duration == ''">
                              </td>
                              <td class="text-center" v-else>
                                {{ item.duration }}
                              </td>
                              <!-- <td class="text-center">
                                {{ item.disconnect_reason }}
                              </td> -->
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <v-card-actions></v-card-actions>
                    </v-container>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
    </div>
  </template>
  <script>
  import { mapState, mapActions } from 'vuex'
  export default {
    data() {
      return {
        jwt: require('jsonwebtoken')
      }
    },
    created() {
        if (localStorage.getItem('user-token') === null) {
      this.$router.push('/')
    } else {
      this.decodejwttoken()
    }
    },
    computed: {
      ...mapState('dialog', ['reporthistory', 'datareporthistory', 'datahistory', 'dataparticipants', 'dataparticipantsend']),
      localDialog: {
      get() {
        return this.reporthistory
      },
      set(value) {
        this.setdialogreporthistory(value)
      }
    }
    },
    mounted() {
    },
    methods: {
      ...mapActions('dialog', ['setdialogreporthistory']),
      decodejwttoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
    },
    setdatestartend(dateInput) {
    // console.log('date', date);
    const date = new Date(`${dateInput}Z`)
    const year = date.getFullYear()
    let month = date.getMonth()+1
    let dt = date.getDate()
    const hh = date.getHours()
    const mm = date.getMinutes()

    if (dt < 10) {
    dt = '0' + dt
    }
    if (month < 10) {
    month = '0' + month
    }
    return `${dt}/${month}/${year}`
    // return `${hh}:${mm}`
},
settimestartend(dateInput) {
    // console.log('date', date);
    const date = new Date(`${dateInput}Z`)
    const year = date.getFullYear()
    let month = date.getMonth()+1
    let dt = date.getDate()
    let ss = date.getUTCSeconds()
    let hh = date.getHours()
    let mm = date.getMinutes()
    mm = mm < 10 ? `0${mm}` : mm
    ss = ss < 10 ? `0${ss}` : ss
    hh = hh < 10 ? `0${hh}` : hh

    if (dt < 10) {
    dt = '0' + dt
    }
    if (month < 10) {
    month = '0' + month
    }
      return `${hh}:${mm}:${ss}`
    // if (hh < 1) {
    //   return `${'0' + hh}:${mm}:${ss}`
    // } else {
    //   return `${hh}:${mm}:${ss}`
    // }
    // return `${dt}/${month}/${year}`
    // return `${hh}:${mm}`
  //  return `${hh}:${mm}`
},
    //   openModeleditroom() {
    //     this.setDialogeditroom(true)
    //   },
    }
  }
  </script>
  